import React, { useState } from "react";
import { useItemCategoryData } from "../../hooks/useItemCategoryData";
import { useOutletContext, useSearchParams } from "react-router-dom";
import NavbarScroll from "../../components/subComponents/NavbarScroll";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import FaqItem from "./FaqItem";
import { saffronURL } from "../../Url";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const {
    selectedCountry,
    selectedCategory,
    selectedLanguage,
    selectedState,
    selectedCity,
  } = useOutletContext();
  const [searchParams, setSearchParams] = useSearchParams();

  // ✅ navbar se aane wala category_name (code)
  const categoryName = searchParams.get("category_name") || "";

  const { data, isPending } = useItemCategoryData({
    key: "connect_faq",
    endpoint: "faqs",
    category_name: categoryName,
    selectedCategory,
    selectedCountry,
    selectedLanguage,
    selectedState,
    selectedCity,
    enabled: true,
    mianURL:saffronURL,
  });

  const getData = data?.data?.faqs



  const {
    data: menuData,
    isLoading: loadingTree,
    error: treeError,
  } = useQuery({
    queryKey: [
      "menuData_connect_slide",
      selectedCountry,
      selectedLanguage,
      selectedCategory,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);

      const url = `${saffronURL}/api/v1/public/menu?${params.toString()}`;
      const resp = await axios.get(url);
      return resp.data;
    },
    enabled: !!(selectedCountry || selectedLanguage || selectedCategory),
    retry: 2,
    staleTime: 1000 * 60 * 10,
    cacheTime: 1000 * 60 * 60,
    placeholderData: undefined,
    onError: (err) => console.warn("Menu fetch error:", err),
  });
  const navbaritems = menuData?.data?.items.find((item) => item.key === "faq");

  const handleCategorySelect = (child) => {
    const params = new URLSearchParams(searchParams);

    // child.code ko URL me save karo
    if (child?.code) params.set("category_name", child.code);
    else params.delete("category_name");

    // optional: reset article view etc.

    setSearchParams(params, { replace: false });
  };

  return (
    <>

      <>
      
        <NavbarScroll
          items={navbaritems}
          activeCode={categoryName} // ✅ highlight
          onSelect={handleCategorySelect} // ✅ set URL + triggers refetch
        />
        <div className="py-3 px-1 md:px-5 lg:px-10">

        <div className="border rounded-md bg-white overflow-hidden">
          {/*  */}
          {getData?.map((faq) => (
          <FaqItem
            key={faq.id}
            faq={faq}
            isOpen={activeIndex === faq.id}
            onToggle={() =>
              setActiveIndex(activeIndex === faq.id ? null : faq.id)
            }
          />
        ))}
        </div>
        </div>
      </>
    </>
  );
};

export default FAQ;